import axios from '@/utils/axios';

/**
 * 登录
 */
export function userLogin(parameter) {
  return axios.formRequest.post('empower/website/login/login', parameter);
}

/**
 * 登出
 */
export function userLogout(parameter) {
  return axios.formRequest.post('empower/website/login/logout', parameter);
}

/**
 * 授权人列表
 */
export function empowerList(parameter) {
  return axios.formRequest.post('empower/website/empower/empower_list', parameter);
}

/**
 * 授权人信息
 */
export function empowerInfo() {
  return axios.formRequest.post('empower/website/login/empower_info', {});
}

/**
 * 模版列表
 */
export function getTemplateList(paramater) {
  return axios.formRequest.post('empower/website/empower/template_list', paramater);
}

/**
 * 报告字段
 */
export function getTemplateField(template_id) {
  return axios.formRequest.post('empower/website/empower/get_template_field', { template_id });
}

/**
 * 报告列表导出 废除
 */
export function getReportDateList(parameter) {
  return axios.formRequest.post('empower/website/empower/report_date_list', parameter);
}

/**
 * 异步导出列表
 */
export function getExportList(parameter) {
  return axios.formRequest.post('empower/website/export/export_list', parameter);
}

/**
 * 授权人详情
 */
export function empowerUserInfo(user_id) {
  return axios.formRequest.post('empower/website/empower/empower_user_info', { user_id });
}

/**
 * 获取模板字段
 */
export function templateField(template_id) {
  return axios.formRequest.post('empower/website/empower/templateField', { template_id });
}

/**
 * 获取模板和报告数量接口
 */
export function getTemplateReportNumber(parameter) {
  return axios.formRequest.post('empower/website/empower/getTemplateReportNumber', parameter);
}

/**
 * 报告列表导出
 */
export function inserExport(parameter) {
  return axios.formRequest.post('empower/website/export/inserExport', parameter);
}

/**
 * 报告列表导出
 */
export function pdfCreate(user_id, template_id, report_code) {
  return axios.formRequest.post('empower/website/empower/pdfCreate', { user_id, template_id, report_code });
}

/**
 * 获取价格
 */
export function getPrice(type) {
  return axios.formRequest.post('pay/pay/getPrice', { type });
}
/**
 * 服务商登录
 */
export function serveLogin(parameter) {
  return axios.formRequest.post('serverclient/website/login/login', parameter);
}
/**
 * 验证登陆账号和企业信息
 */
export function checkCompanyCode(login_account,is_int_server) {
  return axios.formRequest.post('serverclient/website/login/checkCompanyCode', {login_account,is_int_server});
}
/**
 * 发送手机验证码接口
 */
export function sendSms(parameter) {
  return axios.formRequest.post('pay/pay/sendSms', parameter);
}
/**
 * 校验手机验证码
 */
export function checkSms(phone,sms,is_int_server) {
  return axios.formRequest.post('serverclient/website/login/checkSms', {phone,sms,is_int_server});
}
/**
 * 修改密码
 */
export function changePassword(parameter) {
  return axios.formRequest.post('serverclient/website/login/changePassword', parameter);
}
